/**
 * subCasteApi.js
 * --------------
 * API client for Sub-Caste Master using createMasterApiClient.
 * Connects directly to FastAPI backend /sub-caste/ endpoints.
 * Exports are processed asynchronously via JobEngine background jobs (useExportJob).
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const subCasteClient = createMasterApiClient('sub-caste');

export async function listSubCastes(params = {}) {
  return await subCasteClient.list(params);
}

export async function getSubCasteDetail(subCasteId) {
  return await subCasteClient.getById(subCasteId);
}

export async function createSubCaste(payload) {
  return await subCasteClient.create(payload);
}

export async function updateSubCaste(subCasteId, payload) {
  return await subCasteClient.update(subCasteId, payload);
}

export async function archiveSubCaste(subCasteId) {
  return await subCasteClient.archive(subCasteId);
}

export async function deleteSubCaste(subCasteId) {
  return await subCasteClient.remove(subCasteId);
}

export async function getSubCasteOptions() {
  return await subCasteClient.getDropdownOptions();
}
